import { render, staticRenderFns } from "./modalUpdateEdad.vue?vue&type=template&id=64eb4e4e&scoped=true&"
import script from "./modalUpdateEdad.vue?vue&type=script&lang=js&"
export * from "./modalUpdateEdad.vue?vue&type=script&lang=js&"
import style0 from "./modalUpdateEdad.vue?vue&type=style&index=0&id=64eb4e4e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb4e4e",
  null
  
)

export default component.exports